<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {PRODUCT_NAME} from '@/utils/flights/flights-const'

    @Component
    export class FlightStoreMixin extends Vue {
        get productStore() {
            return flightsStore
        }

        get productRuntimeStore() {
            return flightsRuntimeStore
        }

        get productType() {
            return 'flight'
        }

        get productName() {
            return PRODUCT_NAME
        }
    }

    export default FlightStoreMixin
</script>
